"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { useBookingDrawer } from "@/lib/booking-context";
import { useMenuDrawer } from "@/lib/menu-context";
import { regionFromPathname, regionPath } from "@/lib/region";

function isHomepage(pathname: string | null): boolean {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  return p === "/" || p === "/uk";
}

function HamburgerIcon() {
  return (
    <svg
      viewBox="0 0 26 18"
      fill="none"
      aria-hidden
      className="h-[18px] w-[26px] md:h-[21px] md:w-[30px]"
    >
      <path
        d="M1 2h24M1 9h24M1 16h24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function Header() {
  const { setOpen } = useMenuDrawer();
  const { setOpen: setBookingOpen } = useBookingDrawer();
  const pathname = usePathname();
  const region = regionFromPathname(pathname);
  const isHero = isHomepage(pathname);

  return (
    <header
      className={
        isHero
          ? "absolute inset-x-0 top-(--region-banner-h,0px) z-50 lg:hidden"
          : "relative z-50 bg-white lg:hidden"
      }
    >
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-3 px-[clamp(1.25rem,4vw,2.5rem)] py-4">
        <Link
          href={regionPath("/", region)}
          aria-label="thérapie FERTILITY"
          className="block min-w-0 shrink"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={isHero ? "/assets/logo/logo-w.svg" : "/assets/logo/logo-c.svg"}
            alt="Thérapie Fertility Logo"
            width={228}
            height={25}
            className="h-6 w-auto max-[359px]:h-5 md:h-7"
          />
        </Link>
        <div className="flex items-center gap-4">
          {/* Tablet only — phones keep just the hamburger. */}
          <button
            type="button"
            onClick={() => setBookingOpen(true, "header")}
            className={`hidden shrink-0 cursor-pointer items-center justify-center rounded-full px-5 py-2 text-[16px] font-semibold whitespace-nowrap transition-colors md:inline-flex ${
              isHero
                ? "bg-white text-midnight hover:bg-white/90"
                : "bg-purple-03 text-white hover:bg-purple-04"
            }`}
          >
            Free consultation
          </button>
          <button
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className={`shrink-0 p-1 transition-opacity hover:opacity-80 ${
              isHero ? "text-white" : "text-purple-03"
            }`}
          >
            <HamburgerIcon />
          </button>
        </div>
      </div>
    </header>
  );
}
